import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
        },
        text: {
            '& ul':{
                listStyle: 'initial',
                paddingLeft: '1em'
            }
        },
    }));

export type PanelTextProps = PanelTextDto;
type Props = PanelTextProps;

const PanelText: FC<Props> = ({Text}) => {
    const cls = useStyles();

    return (
        <div className={cls.root}>
            <div className={cls.text} dangerouslySetInnerHTML={{ __html: Text}} />
        </div>
    );
}

export default PanelText;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelText.tsx